import en from './en'
import es from './es'
import de from './de'
import vai from './vai'
import gl from './gl'
import eu from './eu'
import ca from './ca'

const locales = {
  en,
  es,
  de,
  vai,
  gl,
  eu,
  ca,
}

export default locales
